import { env, setEnv } from "./stores/env";

const VERSION = Number(0);
const versionKey = 'app_version';

export function getVersion(isUpdate = false) {
  // ENV.version++;
  const store = localStorage.getItem(versionKey) || '';
  let versionSplit = store.split('.').map((it) => Number(it));
  let version =
    isNaN(versionSplit[0]) || versionSplit[0] === 0 ? VERSION : versionSplit[0];
  let subVersion = isNaN(versionSplit[1]) ? 0 : versionSplit[1];
  let finalVersion: string = `${version}.${subVersion}`;
  if (version !== VERSION) {
    version = VERSION;
    finalVersion = `${String(version)}.0`;
  } else if (isUpdate) {
    subVersion++;
    finalVersion = `${version}.${subVersion}`;
    env.version = finalVersion;
  }
  localStorage.setItem(versionKey, finalVersion);
  return finalVersion;
}

setEnv({
  /** 开发环境，包括内网测试域名 */
  isDev: import.meta.env.VITE_ENV === 'DEV',
  isTest: import.meta.env.VITE_ENV === 'TEST',
  isProd: import.meta.env.VITE_ENV === 'PROD',
  /** 图片域名 */
  imgHost: "",
  version: String(import.meta.env.VITE_VERSION) || getVersion(),
  /** 网站名称 */
  siteName: String(import.meta.env.VITE_SITENAME),
  /** 平台币 */
  platformCoin: String(import.meta.env.VITE_BCD),
  /** 支持邮箱 */
  SUPPORT: String(import.meta.env.VITE_SUPPORT),
  FEEDBACK: String(import.meta.env.VITE_FEEDBACK),
  langs: {
    //印度英语  印度地区
    'en-IN': ['Indian English', 'en-IN'],
    en: ['English', 'en-US'],
    // 越南语
    vi: ['Tiếng việt', 'vi-VN'],
    // 印度尼西亚语
    id: ['Indonesian', 'id-ID'],
    // 日本语
    ja: ['日本語', 'ja-JP'],
    // 韩语
    ko: ['한국어', 'ko-KR'],
    // 法语
    fr: ['Français', 'fr-FR'],
    // 西班牙语
    es: ['Español', 'es-ES'],
    // 菲律宾语
    tl: ['Filipino', 'fil-PH'],
    // 阿拉伯语
    ar: ['عربى', 'ar-SA'],
    // 印地语
    hi: ['हिन्दी', 'hi-IN'],
    // 土耳其语
    tr: ['Türkçe', 'tr-TR'],
    // 波斯语
    fa: ['فارسی', 'fa-IR'],
    // 葡萄牙语(巴西)
    pt: ['Português', 'pt-BR'],
    // 俄语
    ru: ['Руccкий', 'ru-RU'],
    // 德语
    de: ['Deutsch', 'de-DE'],
    // 泰语
    th: ['ภาษาไทย', 'th-TH'],
    // 芬兰
    fi: ['Suomi', 'fi-FI'],
    // 波兰
    pl: ['Polski', 'pl-PL'],
    // 意大利
    it: ['Italiano', 'it-IT'],
    // 缅甸语 Burmese
    my: ['မြန်မာ', 'my-MM'],
    // 荷兰语 Dutch 暂时去掉荷兰语
    //"nl": ["Nederlands", "nl-NL"],
    // 乌尔都语（巴基斯坦）Urdu (Pakistan)
    ur: ['اردو', 'ur-PK'],
    //乌克兰语
    uk: ['Українська', 'uk-UA'],
    //马来西亚语
    ms: ['Melayu', 'ms-MY'],
    //孟加拉语
    bn: ['বাংলা', 'bn-BD'],
    //马拉地语  印度地区
    mr: ['Marathi', 'mr-IN'],
    //泰米尔语  印度地区
    ta: ['Tamil', 'ta-IN'],
    //泰卢固语  印度地区
    te: ['Telugu', 'te-IN'],
  },
});

export default env;
